import { PAGINATION_RECORD_PER_PAGE } from "MainApp/features/App/constants";

export const HASH_TAG_POSTS_PER_PAGE = PAGINATION_RECORD_PER_PAGE;